import _slicedToArray from '../../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js';
import _defineProperty from '../../../node_modules/@babel/runtime/helpers/esm/defineProperty.js';
import React__default, { useState, useEffect, Suspense, lazy } from 'react';
import PropTypes__default from 'prop-types';
import clsx from 'clsx';
import { useBreakpoints } from '../../hooks/useBreakpoints.js';
import { BREAKPOINT_XS, BREAKPOINT_SM, BREAKPOINT_MD, BREAKPOINT_LG, BREAKPOINT_XL } from '../../common/constant.js';
import { makeStyles, Box, Grid, Typography } from '@material-ui/core';
import ArrowBackIcon from '../../widgets/streamline-icon/ArrowBackIcon.js';
import ArrowForwardIcon from '../../widgets/streamline-icon/ArrowForwardIcon.js';
import CustomIconButton from '../../widgets/button/custom-icon-button/CustomIconButton.js';
import ShareholderCard from '../../widgets/card/ShareholderCard.js';

var ItemsCarousel = /*#__PURE__*/lazy(function () {
  return import('react-items-carousel');
});
var useStyles = makeStyles(function (theme) {
  return {
    root: _defineProperty({
      paddingTop: theme.spacing(7.5)
    }, theme.breakpoints.down("xs"), {
      paddingLeft: theme.spacing(2)
    }),
    title: {
      height: theme.spacing(4.375),
      marginBottom: theme.spacing(10)
    },
    carouselContainer: _defineProperty(_defineProperty(_defineProperty({
      width: theme.spacing(48)
    }, theme.breakpoints.up("sm"), {
      width: theme.spacing(50)
    }), theme.breakpoints.up("md"), {
      width: theme.spacing(96)
    }), theme.breakpoints.up("lg"), {
      width: theme.spacing(143)
    }),
    itemsWrapper: {
      borderRadius: theme.spacing(1)
    },
    chevronWrapper: _defineProperty({
      position: "relative !important",
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      display: "none !important"
    }, theme.breakpoints.up("md"), {
      display: "block !important"
    }),
    leftChevronWrapper: _defineProperty(_defineProperty({}, theme.breakpoints.up("md"), {
      left: "43% !important;"
    }), theme.breakpoints.down("md"), {
      left: "35% !important;"
    }),
    rightChevronWrapper: _defineProperty(_defineProperty({
      "float": "right"
    }, theme.breakpoints.up("md"), {
      right: "43% !important;"
    }), theme.breakpoints.down("md"), {
      right: "35% !important;"
    }),
    btn: {
      background: theme.palette.primary.main
    },
    btnInner: {
      color: theme.palette.text.black + " !important;",
      "& i": {
        color: theme.palette.text.black + " !important;"
      },
      "&:disabled i": {
        color: theme.palette.grey[300] + " !important;"
      }
    },
    arrow: {
      lineHeight: "1px",
      fontSize: theme.spacing(3.5) + "px !important;"
    }
  };
});
var HowManyShares = function HowManyShares(_ref) {
  var bgColor = _ref.bgColor,
    title = _ref.title,
    elements = _ref.elements,
    labelShares = _ref.labelShares,
    labelShare = _ref.labelShare;
  var classes = useStyles();
  var _useBreakpoints = useBreakpoints(),
    getBreakpoint = _useBreakpoints.getBreakpoint;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    activeItemIndex = _useState2[0],
    setActiveItemIndex = _useState2[1];
  var _useState3 = useState(1),
    _useState4 = _slicedToArray(_useState3, 2),
    numOfShownItems = _useState4[0],
    setNumOfShownItems = _useState4[1];
  var currentBreakPoint = getBreakpoint();
  useEffect(function () {
    switch (currentBreakPoint) {
      case BREAKPOINT_XL:
      case BREAKPOINT_LG:
        setNumOfShownItems(3);
        break;
      case BREAKPOINT_MD:
        setNumOfShownItems(2);
        break;
      case BREAKPOINT_SM:
        setNumOfShownItems(1);
        break;
      case BREAKPOINT_XS:
        setNumOfShownItems(1);
        break;
      default:
        setNumOfShownItems(1);
    }
  }, [currentBreakPoint]);
  return /*#__PURE__*/React__default.createElement(Box, {
    bgcolor: bgColor
  }, /*#__PURE__*/React__default.createElement(Grid, {
    className: classes.root,
    container: true,
    direction: "column",
    alignContent: "center",
    alignItems: "center"
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    lg: 12,
    className: classes.title
  }, title && /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h3",
    component: "h2",
    align: "center"
  }, title)), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    className: classes.carouselContainer
  }, (elements === null || elements === void 0 ? void 0 : elements.length) && /*#__PURE__*/React__default.createElement(Suspense, {
    fallback: /*#__PURE__*/React__default.createElement("div", null)
  }, /*#__PURE__*/React__default.createElement(ItemsCarousel, {
    infiniteLoop: false,
    enablePlaceholder: true,
    numberOfPlaceholderItems: numOfShownItems,
    gutter: 16,
    activePosition: "left",
    chevronWidth: 60,
    disableSwipe: false,
    alwaysShowChevrons: true,
    numberOfCards: numOfShownItems,
    slidesToScroll: 1,
    outsideChevron: true,
    showSlither: numOfShownItems === 1,
    firstAndLastGutter: false,
    activeItemIndex: activeItemIndex,
    requestToChangeActive: setActiveItemIndex,
    leftChevron: /*#__PURE__*/React__default.createElement(CustomIconButton, {
      className: classes.btnInner,
      color: activeItemIndex === 0 ? "secondary" : "primary",
      disabled: activeItemIndex === 0
    }, /*#__PURE__*/React__default.createElement(ArrowBackIcon, {
      className: classes.arrow
    })),
    rightChevron: /*#__PURE__*/React__default.createElement(CustomIconButton, {
      className: classes.btnInner,
      color: activeItemIndex === (elements === null || elements === void 0 ? void 0 : elements.length) - numOfShownItems ? "secondary" : "primary",
      disabled: activeItemIndex === (elements === null || elements === void 0 ? void 0 : elements.length) - numOfShownItems
    }, /*#__PURE__*/React__default.createElement(ArrowForwardIcon, {
      className: classes.arrow
    })),
    classes: {
      rightChevronWrapper: clsx(classes.chevronWrapper, classes.rightChevronWrapper),
      leftChevronWrapper: clsx(classes.chevronWrapper, classes.leftChevronWrapper),
      itemsWrapper: clsx(classes.itemsWrapper)
    }
  }, elements === null || elements === void 0 ? void 0 : elements.map(function (cardDetail, index) {
    return /*#__PURE__*/React__default.createElement(ShareholderCard, {
      key: index,
      imageTitle: cardDetail === null || cardDetail === void 0 ? void 0 : cardDetail.imageTitle,
      imageUrl: cardDetail === null || cardDetail === void 0 ? void 0 : cardDetail.imageUrl,
      name: cardDetail === null || cardDetail === void 0 ? void 0 : cardDetail.name,
      memberSince: cardDetail === null || cardDetail === void 0 ? void 0 : cardDetail.memberSince,
      exampleFor: cardDetail === null || cardDetail === void 0 ? void 0 : cardDetail.exampleFor,
      journeys: cardDetail === null || cardDetail === void 0 ? void 0 : cardDetail.journeys,
      numberOfShares: cardDetail === null || cardDetail === void 0 ? void 0 : cardDetail.numberOfShares,
      labelShare: labelShare,
      labelShares: labelShares
    });
  }))))));
};
HowManyShares.propTypes = {
  bgColor: PropTypes__default.string,
  title: PropTypes__default.string,
  elements: PropTypes__default.array,
  labelShares: PropTypes__default.string,
  labelShare: PropTypes__default.string
};

export { HowManyShares as default };
//# sourceMappingURL=HowManyShares.js.map
